<template>
  <div class="page flex-col">
    <div class="flex-col">
      <div class="group_3 flex-col">
        <div class="text-wrapper_1 flex-row">
          <span class="text_11" style="cursor: pointer" @click="handleJump('/about')">关于我们</span>
          <span class="text_12" style="cursor: pointer" @click="handleJump('/system')">服务体系</span>
          <span class="text_13" style="cursor: pointer" @click="handleJump('/join')">加入我们</span>
          <span class="text_14" style="cursor: pointer" @click="handleJump('/contact')">联系我们</span>
          <span class="text_15">其它公司</span>
        </div>
        <div class="text-wrapper_2 flex-row">
          <span class="text_16" style="cursor: pointer" @click="handleJump('/about', { select: 1 })">公司简介</span>
          <span class="text_17" style="cursor: pointer" @click="handleJump('/system', { select: 1 })">食堂经营管理</span>
          <span class="text_18" style="cursor: pointer" @click="handleJump('/join', { top: 1 })">企业构想</span>
          <span class="text_19">地址：重庆市璧山区璧泉街道1001号附25号</span>
          <span class="text_20">重庆振勤康存商业管理有限公司</span>
        </div>
        <div class="text-wrapper_3 flex-row">
          <span class="text_21" style="cursor: pointer" @click="handleJump('/about', { select: 2 })">发展历程</span>
          <span class="text_22" style="cursor: pointer" @click="handleJump('/system', { select: 2 })">商贸超市管理</span>
          <span class="text_23" style="cursor: pointer" @click="handleJump('/join', { top: 2 })">企业现状</span>
          <span class="text_24">电话：13368156780&nbsp;&nbsp;&nbsp;&nbsp;13523356555</span>
          <span class="text_25">重庆名耀后勤管理有限公司</span>
        </div>
        <div class="text-wrapper_4 flex-row justify-between">
          <span class="text_26" style="cursor: pointer" @click="handleJump('/about', { select: 3 })">企业文化</span>
          <span class="text_27" style="cursor: pointer" @click="handleJump('/system', { select: 3 })">商业体管理</span>
          <span class="text_28" style="cursor: pointer" @click="handleJump('/join', { top: 3 })">企业领域</span>
          <span class="text_29">邮箱：379085456&#64;qq.com</span>
        </div>
        <div class="text-wrapper_5 flex-row justify-between">
          <span class="text_30" style="cursor: pointer" @click="handleJump('/system', { select: 4 })">后勤管理</span>
          <span class="text_31" style="cursor: pointer" @click="handleJump('/join', { top: 4 })">市场规模</span>
        </div>
        <span class="text_32" style="cursor: pointer" @click="handleJump('/system', { select: 5 })">掌上校园管理</span>
        <div class="group_4 flex-col"></div>
        <span class="text_33">
<!--          CopyRight&nbsp;©&nbsp;2024&nbsp;海南鼎言智造商业管理有限公司&nbsp;版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="cursor: pointer" @click="handleOpen('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=2024037171')">渝公网安备&nbsp;2024037171号</span>&nbsp;&nbsp;&nbsp;<span style="cursor: pointer" @click="handleOpen('https://beian.miit.gov.cn/')">琼ICP备2024037171号</span>-->
          CopyRight&nbsp;©&nbsp;2024&nbsp;海南鼎言智造商业管理有限公司&nbsp;版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="cursor: pointer" @click="handleOpen('https://beian.miit.gov.cn/')">琼ICP备2024037171号</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    handleJump(url, data = {}) {
      if (url === this.$route.path) {
        window.scrollTo(0,0);
        return;
      }
      this.$router.push({
        path: url,
        query: data
      });
      window.scrollTo(0,0);
    },
    handleOpen(url) {
      window.open(url, '_blank');
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
